
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainShowersDayColour as ObiRainShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-showers-day-colour.js';
 
 
 

 
 export const ObiRainShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-rain-showers-day-colour',
   elementClass: ObiRainShowersDayColourElement,
   events: {
     
   }
  });
 
 